import { pathDriver, pathDriverVehicle, pathUserTransactions } from './routes';

/** Reject path traversal or odd segments from untrusted notification payloads. */
const SAFE_ROUTE_SEGMENT = /^[a-zA-Z0-9_-]+$/;

/** Route segment cap — avoids absurdly long URLs from hostile payloads. */
const MAX_ROUTE_SEGMENT_LENGTH = 256;

const safeSegment = (value) => {
  if (value == null || value === '') return null;
  const s = String(value).trim();
  if (s === '' || s.length > MAX_ROUTE_SEGMENT_LENGTH) return null;
  return SAFE_ROUTE_SEGMENT.test(s) ? s : null;
};

const pathForEntityUser = (entityId, buildPath) => {
  const userId = safeSegment(entityId);
  return userId ? buildPath(userId) : null;
};

const NOTIFICATION_TYPES = {
  accountVerificationPending: 'ACCOUNT_VERIFICATION_PENDING',
  serviceVerificationPending: 'SERVICE_VERIFICATION_PENDING',
  carVerificationPending: 'CAR_VERIFICATION_PENDING',
  withdrawalVerificationPending: 'WITHDRAWAL_VERIFICATION_PENDING',
  fileVerificationPending: 'FILE_VERIFICATION_PENDING',
};

export const NOTIFICATION_TYPE_LABELS = {
  [NOTIFICATION_TYPES.accountVerificationPending]: 'Nouvelle inscription utilisateur',
  [NOTIFICATION_TYPES.serviceVerificationPending]: 'Nouvelle demande de service',
  [NOTIFICATION_TYPES.carVerificationPending]: 'Nouvelle demande de véhicule',
  [NOTIFICATION_TYPES.withdrawalVerificationPending]: 'Nouvelle demande de retrait',
  [NOTIFICATION_TYPES.fileVerificationPending]: 'Nouveau téléchargement de fichier',
};

export const NOTIFICATION_TYPE_SUBTITLES = {
  [NOTIFICATION_TYPES.accountVerificationPending]: (actor) => `${actor} a créé un nouveau compte`,
  [NOTIFICATION_TYPES.serviceVerificationPending]: (actor) =>
    `${actor} a soumis une nouvelle demande de service`,
  [NOTIFICATION_TYPES.carVerificationPending]: (actor) =>
    `${actor} a soumis une nouvelle demande de véhicule`,
  [NOTIFICATION_TYPES.withdrawalVerificationPending]: (actor) =>
    `${actor} a soumis une nouvelle demande de retrait`,
  [NOTIFICATION_TYPES.fileVerificationPending]: (actor) =>
    `${actor} a téléchargé un nouveau fichier`,
};

/**
 * Returns the in-app path to open for a normalized notification.
 * @param {{ type?: string, actorId?: unknown, entityId?: unknown }|null|undefined} notification
 * @returns {string|null}
 */
export const getNotificationRoute = (notification) => {
  if (notification == null || typeof notification.type !== 'string') {
    return null;
  }
  const { actorId, entityId, type } = notification;

  switch (type) {
    case NOTIFICATION_TYPES.accountVerificationPending:
    case NOTIFICATION_TYPES.serviceVerificationPending:
      return pathForEntityUser(entityId, pathDriver);
    case NOTIFICATION_TYPES.fileVerificationPending: {
      const a = safeSegment(actorId);
      const e = safeSegment(entityId);
      if (!a || !e) return null;
      return a !== e ? pathDriverVehicle(a, e) : pathDriver(e);
    }
    case NOTIFICATION_TYPES.carVerificationPending: {
      const a = safeSegment(actorId);
      const e = safeSegment(entityId);
      return a && e ? pathDriverVehicle(a, e) : null;
    }
    case NOTIFICATION_TYPES.withdrawalVerificationPending:
      return pathForEntityUser(entityId, pathUserTransactions);
    default:
      return null;
  }
};
